import React from "react";
import "./SectorsSection.css";

const Landscapingsection = () => {
  const sectors = [
  "Corporate Campuses",
  "IT Parks",
  "Residential Societies",
  "Hotels & Resorts",
  "Educational Institutions",
  "Hospitals",
  "Industrial Parks",
  "Golf Courses",
  "Public Parks",
  "Commercial Complexes",
  "Government Buildings",
  "Gated Communities"
];


  return (
    <section className="sector-section-wrapper">
      <div className="sector-section-container">
        <h2 className="sector-section-title">Trusted Across Sectors</h2>
        <p className="sector-section-subtitle">
          Serving diverse industries with excellence
        </p>

        <div className="sector-tags-wrapper">
          {sectors.map((sector, index) => (
            <span key={index} className="sector-tag">
              {sector}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Landscapingsection;
